import { Helmet } from "react-helmet";

export default function Datenschutzerklaerung() {
  return (
    <>
      <Helmet>
        <title>Datenschutzerklärung – Kanzlei Preisner</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="mx-auto max-w-4xl px-6 py-12 text-slate-800">
        <h1 className="text-3xl font-semibold mb-6">Datenschutzerklärung</h1>

        <p className="mb-4">
          Diese Datenschutzerklärung informiert Sie über die Verarbeitung personenbezogener Daten auf dieser Website gemäß DSGVO.
        </p>

        {/* 1. Verantwortlicher */}
        <h2 className="text-xl font-semibold mt-8 mb-3">1. Verantwortlicher</h2>
        <p className="mb-4">
          Rechtsanwalt Thomas M. Preisner<br />
          Koloniestraße 21<br />
          13359 Berlin<br />
          E-Mail:{" "}
          <a href="mailto:info@kanzlei-preisner.de" className="underline">
            info@kanzlei-preisner.de
          </a>
        </p>

        {/* 2. Keine Cookies / kein Tracking */}
        <h2 className="text-xl font-semibold mt-8 mb-3">2. Keine Cookies, kein Tracking, keine Analyse</h2>
        <p className="mb-4">
          Beim Besuch dieser Website werden{" "}
          <strong>keine personenbezogenen Daten automatisiert gespeichert oder ausgewertet</strong>.
          Es werden insbesondere:
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li>keine Cookies gesetzt,</li>
          <li>kein Tracking durchgeführt (z. B. Google Analytics),</li>
          <li>keine Social-Media-Plugins eingebunden.</li>
        </ul>

        {/* 3. Kontaktformular */}
        <h2 className="text-xl font-semibold mt-8 mb-3">3. Kontaktaufnahme (Kontaktformular / E-Mail)</h2>
        <p className="mb-4">
          Das Kontaktformular erzeugt ausschließlich eine <strong>vorbefüllte E-Mail</strong> in Ihrem lokalen E-Mail-Programm.
          <br />
          Die eingegebenen Daten werden:
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li>nicht auf dem Server gespeichert,</li>
          <li>nicht an Dritte weitergegeben,</li>
          <li>nicht durch diese Website verarbeitet oder übertragen.</li>
        </ul>
        <p className="mb-4">
          Rechtsgrundlage für die Datenverarbeitung im Rahmen der E-Mail-Kommunikation ist Art. 6 Abs. 1 lit. b DSGVO
          (vorvertragliche Kommunikation).
        </p>

        {/* 4. Server-Logs */}
        <h2 className="text-xl font-semibold mt-8 mb-3">4. Server-Logfiles</h2>
        <p className="mb-4">
          Der technische Betrieb dieser Website erfolgt über den Hostinganbieter:
        </p>

        <p className="mb-4">
          ALL-INKL.COM – Neue Medien Münnich<br />
          Hauptstraße 68, D-02742 Friedersdorf
        </p>

        <p className="mb-4">
          Beim Aufruf dieser Website speichert der Hoster automatisch folgende Informationen (Server-Logfiles):
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li>Browsertyp und Browserversion</li>
          <li>verwendetes Betriebssystem</li>
          <li>Hostname des zugreifenden Rechners</li>
          <li>Datum und Uhrzeit der Serveranfrage</li>
          <li>IP-Adresse (gekürzt/anonymisiert)</li>
        </ul>
        <p className="mb-4">
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am Betrieb der Website).
        </p>

        {/* 5. Rechte */}
        <h2 className="text-xl font-semibold mt-8 mb-3">5. Ihre Rechte</h2>
        <ul className="list-disc ml-6 mb-4">
          <li>Auskunft (Art. 15 DSGVO)</li>
          <li>Berichtigung (Art. 16 DSGVO)</li>
          <li>Löschung (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Widerspruch (Art. 21 DSGVO)</li>
        </ul>

        {/* 6. Aufsichtsbehörde */}
        <h2 className="text-xl font-semibold mt-8 mb-3">6. Beschwerderecht bei der Aufsichtsbehörde</h2>
        <p className="mb-4">
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig ist:
        </p>
        <p className="mb-4">
          Berliner Beauftragte für Datenschutz und Informationsfreiheit<br />
          Friedrichstraße 219, 10969 Berlin<br />
          E-Mail: mailbox@datenschutz-berlin.de
        </p>

        {/* 7. B2B Hinweis */}
        <h2 className="text-xl font-semibold mt-8 mb-3">7. Keine Mandate von Verbrauchern (B2B)</h2>
        <p className="mb-4">
          Über diese Website werden ausschließlich Terminsvertretungen für <strong>Anwaltskanzleien</strong> angeboten.
          Es erfolgt keine Mandatsannahme gegenüber Verbrauchern gemäß § 13 BGB.
        </p>

        {/* 8. Aktualisierung */}
        <h2 className="text-xl font-semibold mt-8 mb-3">8. Aktualisierung dieser Erklärung</h2>
        <p>Stand: {new Date().getFullYear()}</p>
      </div>
    </>
  );
}
